import React, { useEffect } from 'react'
import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext'
import { uuidv4 } from '@firebase/util'
import GroupChannelHandler from '@sendbird/uikit-react/handlers/GroupChannelHandler'
import sendbirdSelectors from '@sendbird/uikit-react/sendbirdSelectors'
import { BaseChannel } from '@sendbird/chat'
import { BaseMessage } from '@sendbird/chat/message'

type Props = {
  channelUrl: string
  play: () => void
}

export default function Messages({ channelUrl, play }: Props) {
  const context = useSendbirdStateContext()
  const sdkInstance = sendbirdSelectors.getSdk(context)

  useEffect(() => {
    const uuid = uuidv4()
    if (sdkInstance?.groupChannel?.addGroupChannelHandler) {
      const groupChannelHandler = new GroupChannelHandler({
        onMessageReceived: (channel: BaseChannel, message: BaseMessage) => {
          if (channel.url === channelUrl) play()
        },
        onChannelChanged: (channel: BaseChannel) => {},
      })
      sdkInstance?.groupChannel?.addGroupChannelHandler(
        uuid,
        groupChannelHandler,
      )
    }

    return () => {
      if (sdkInstance?.groupChannel?.removeGroupChannelHandler) {
        sdkInstance?.groupChannel?.removeGroupChannelHandler(uuid)
      }
    }
  }, [sdkInstance])

  return <div></div>
}
